/** 작업 단위 화면(`W-30` 정산 줄 · `W-31` 정산 배너)에서 **계정 단위 기록**(`W-70` 결제
 * 이력의 그 행)으로 넘어가는 유일한 길.
 *
 * **명세 정본은 한 화면이다**(PRD S3b). 작업 쪽에서 명세를 다시 쓰지 않고 이리로 보낸다 —
 * 앱이 `A-31` 의 금액 줄에서 `A-43b` 로 화면을 옮기는 것과 같은 동작이고, 웹에서는 그 결제
 * 행이 **펼쳐진 상태로** 열리고 그 행으로 스크롤한다.
 *
 * 주소에 담는 것은 **작업 id** 다. 결제 id 가 아니라 작업 id 인 이유는 부르는 쪽이 작업
 * 화면이고, 한 작업의 결제 행을 찾는 일은 목록을 가진 `W-70` 이 해야 하기 때문이다. */
export const SETTLEMENT_PARAM = "settlement";

export function settlementPath(jobId: string): string {
  return `/account?${SETTLEMENT_PARAM}=${encodeURIComponent(jobId)}`;
}
